/**
 * @generated SignedSource<<ec2c6f808ecb5ba3ebddbb1ad75d2cb3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Profile_AtlassianGlobalTopNavigation$data = {
  readonly me: {
    readonly user: {
      readonly email?: string | null;
      readonly picture: AGG$URL;
    } | null;
  };
  readonly " $fragmentType": "Profile_AtlassianGlobalTopNavigation";
};
export type Profile_AtlassianGlobalTopNavigation$key = {
  readonly " $data"?: Profile_AtlassianGlobalTopNavigation$data;
  readonly " $fragmentSpreads": FragmentRefs<"Profile_AtlassianGlobalTopNavigation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Profile_AtlassianGlobalTopNavigation",
  "selections": [
    {
      "concreteType": "AuthenticationContext",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "picture"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "30bea4dec85ca80641a57259f04a789a";

export default node;
